/**
 * Ce fichier permets d'afficher la positions du point de toucher
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */
/*-------------------------------------------------------------------------------------------*/
import { useEffect } from 'react';
import mapboxgl from 'mapbox-gl';

import PropTypes from 'prop-types';

import { map } from './Map';

/*-------------------------------------------------------------------------------------------*/

PositionsAero.propTypes = {
  aero: PropTypes.object
};
export default function PositionsAero({ aero }) {
  useEffect(() => {
    const mapMarkers = [];

    const marker = new mapboxgl.Marker({ color: '#22398d' });

    marker.setLngLat([aero.lon, aero.lat]);
    marker.addTo(map);
    mapMarkers.push(marker);

    map.flyTo({
      center: [aero.lon, aero.lat],
      essential: true // this animation is considered essential with respect to prefers-reduced-motion
    });

    return () => marker.remove();
  }, [aero]);

  return null;
}
